export default class SingleResponseService {
    /**
     * Returns the data from a single response and throws an error if success is equal to false.
     *
     * @param {SingleResponse<T>} singleResponse - the single response
     * @throws {Error} when the single response has success false
     * @returns {T} data from the single response
     */
    static processSingleResponse(singleResponse) {
        if (!singleResponse.success) {
            if (console.error) {
                console.error(singleResponse);
            }
            throw (singleResponse.message ||
                "Invalid single response: " + singleResponse.toString());
        }
        return singleResponse.data;
    }
}
